<template>
  <div class="autoGraph-container">
    <vue-esign ref="esign" :width="800" :height="480" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
    <div class="autoGraph-btns">
      <div @click="handleReset" style="color: #323233;">清空</div>
      <div @click="handleGenerate" style="color: #1584FF;">确定</div>
    </div>
  </div>
</template>

<script>
import { upload, signFor } from "../axios/services";
import { Toast } from "vant";
export default {
  data() {
    return {
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false
    }
  },
  props: ['recordId'],
  methods: {
    handleReset() {
      this.$refs.esign.reset()
    },
    base64toFile(base64Data) {
      //去掉base64的头部信息，并转换为byte
      let split = base64Data.split(',');
      let bytes = window.atob(split[1]);
        //获取文件类型
      let fileType = split[0].match(/:(.*?);/)[1];
      //处理异常,将ascii码小于0的转换为大于0
      let ab = new ArrayBuffer(bytes.length);
      let ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], { type: fileType});
    },
    handleGenerate() {
      this.$refs.esign.generate().then(res => {
        if(res) {
          let formData = new FormData();
          let file = this.base64toFile(res);
          formData.append('file', file);
          upload(formData).then(res => {
            if(res.data.code === 0) {
              const params = {
                recordId: this.recordId,
                resourcesId: res.data.data.resourcesId
              }
              signFor(params).then(res => {
                if(res.data.code === 0) {
                  this.$emit('showModal')
                  Toast('操作成功')
                  setTimeout(() => {
                    window.location.href = "jsToOc://back";
                  },1000)
                }else {
                  Toast.fail(res.data.msg)
                }
              })
            }
          })
        }
      }).catch(err => {
        console.log(err);
      })
    },
  }
}
</script>

<style scoped>
  .autoGraph-container {
    width: 8.29rem;
    height: 6.29rem;
    background: #FFFFFF;
    border-radius: 0.05rem;
  }
  .autoGraph-btns {
    width: 8.29rem;
    height: 1.28rem;
    background: #FFFFFF;
    border-radius: 0rem 0rem 0.11rem 0.11rem;
    font-size: 0.43rem;
    display: flex;
  }
  .autoGraph-btns div {
    width: 4.15rem;
    height: 1.28rem;
    line-height: 1.28rem;
    text-align: center;
  }
</style>